__turbopack_context__.v({
  "authorName": "JmtcVW_authorName",
  "date": "JmtcVW_date",
  "stageFooter": "JmtcVW_stageFooter",
  "text": "JmtcVW_text",
});
